import { render, staticRenderFns } from "./addPolicyList.vue?vue&type=template&id=5ace61a8&"
import script from "./addPolicyList.vue?vue&type=script&lang=js&"
export * from "./addPolicyList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports